import type {BaseCar} from "@/types";


export const getStatusColor = (status: BaseCar['active']) => status && ({
    draft: "gold",
    active: "green",
    live: "lime",
    pending: "orange",
    inactive: "default",
    sold: "blue",
    expired: "red",
}[status]);